import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { useSupportPanel } from 'Context/Support';
import { Spinner } from 'Components/Spinner';

import { ConversationListItem } from './ConversationListItem';

import classes from './conversationList.module.css';

function ConversationList() {
  const { conversations, loading, openConversation, startNewConversation } = useSupportPanel();

  return (
    <div className={classes.container}>
      <button type="button" className={classes.newButton} onClick={startNewConversation}>
        + New Conversation
      </button>

      {loading && conversations.length === 0 ? (
        <div className={classes.loadingContainer}>
          <Spinner loading />
        </div>
      ) : conversations.length === 0 ? (
        <div className={classes.emptyState}>
          <div className={classes.emptyTitle}>No conversations yet</div>
          <div className={classes.emptyText}>Start a conversation with our support team.</div>
          <button type="button" className={classes.newButton} onClick={startNewConversation}>
            Get Help
          </button>
        </div>
      ) : (
        <div className={classes.list}>
          {conversations.map((conv) => (
            <ConversationListItem key={conv.id} conversation={conv} onClick={openConversation} />
          ))}
        </div>
      )}
    </div>
  );
}

const ConversationListMemo = memo(ConversationList, areEqual);

export { ConversationListMemo as ConversationList };
